import { IDate } from '@avantstay/arriere-clients/dist/arriereBackoffice'

import { RunFlags } from '../../StayTimeline.items'
import { GuestInboxTimelineEvent } from '../../StayTimeline.types'
import { GuestMessage } from './components/GuestMessage'
import { InternalNote, NoteActionsConfig } from './components/InternalNote'
import { BubbleVariant } from './components/MessageBubble/MessageBubble.styles'
import { TeamMessage } from './components/TeamMessage'

interface TimelineEventProps {
  event: GuestInboxTimelineEvent
  variant: BubbleVariant
  flags: RunFlags
  guestName?: string | null
  checkIn?: IDate | null
  checkout?: IDate | null
  noteActions?: NoteActionsConfig
}

export const TimelineEvent = ({
  event,
  variant,
  flags,
  guestName,
  checkIn,
  checkout,
  noteActions,
}: TimelineEventProps) => {
  if (variant === 'note') {
    return (
      <InternalNote
        event={event}
        flags={flags}
        checkIn={checkIn}
        checkout={checkout}
        actions={noteActions}
      />
    )
  }

  if (variant === 'in') {
    return (
      <GuestMessage
        event={event}
        flags={flags}
        guestName={guestName}
        checkIn={checkIn}
        checkout={checkout}
      />
    )
  }

  return (
    <TeamMessage
      event={event}
      flags={flags}
      isAi={variant === 'ai'}
      checkIn={checkIn}
      checkout={checkout}
    />
  )
}
